<template>
    <div class="card">
        <div style="border:1px solid #ccc;overflow: hidden;">
            <div class="Project_box" v-for="(item, index) in this.project" :key="index">
                <div> Study ID : {{ item.externalStudyId }}</div>
                <div  class="Project_tit" :title="item.projectName" @click="goSampleStatus(item.projectName)">Project Name:{{ item.projectName }}</div>
                <div   class="Project_tit" :title="item.projectId" @click="goSampleStatus(item.projectName)">Project ID:{{ item.projectId }}</div>
                <template v-if="isShowProject=='Y'">
                    <div>Total Samples: {{ item.total }}</div>
                    <div style="text-align:right;padding-right:80px;">Sample Status</div>
                    <div ref="chart" style="height: 110px;"></div>
                </template>
                <div style="height: 33px;">
                    <Button v-if='item.reportUrl' @click="goReport(item.reportUrl)" style="float:right;">Report</Button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import * as echarts from 'echarts';
import requests from '@/request';
export default {
    name: 'Project',
    data() {
        return {
            micAccountName: localStorage.getItem('micAccountName'),
            project: [],
            sharedLink : "",
            isShowProject:localStorage.getItem("isShowProject")
        };
    },
    mounted() {
        // setTimeout(() => {
        // //    this.project = [
        // //         {
        // //            projectName: 'PD-OQ-Project1',
        // //            projectId: 'PP0116A0001',
        // //            total: 3,
        // //            status: {
        // //                isTotal: 400,
        // //                isAccessioned: 100,
        // //                isUsed: 200,
        // //                isDestroyed: 300,
        // //               }
        // //          }
        // //     ]
        //     this.$nextTick(() => {
        //         for (let i in this.project) {
        //             this.initCharts(i, this.project[i]);
        //         }
        //     })
        // }, 1000);
        requests({
            url: '/user/sampleByProject',
            data: {
                micAccountName: this.micAccountName
            }
        }).then(res => {
            this.project = res.data.data;
            this.$nextTick(() => {
                for (let i in this.project) {
                    this.initCharts(i, this.project[i]);
                }
            })
        })
    },
    methods: {
        goReport(reportUrl) {
           //在这里 加一个跳转链接
           this.sharedLink = reportUrl;
            window.open(this.sharedLink,'_blank')
        },
        goSampleStatus(project) {
            sessionStorage.setItem('urlQuery', JSON.stringify({ id: project }))
            this.$router.push({ name: 'SampleStatus' })
        },
        initCharts(i, project) {
            let myChart = echarts.init(this.$refs.chart[i]);
            let option = {
                title: {
                    text: 'Sample Status',
                    left: 'right',  // 标题水平居中
                    show: false  // 隐藏标题
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    axisLabel: {
                        show: false  // 隐藏刻度标签
                    }
                },
                yAxis: {
                    type: 'category',
                    inverse: true,  // 关键设置
                    data: ['Total Samples', 'In Storage','Processing', 'Destroyed',]
                },
                series: [
                    {
                        type: 'bar',
                        data: [project.status.isTotal,project.status.isAccessioned,project.status.isUsed, project.status.isDestroyed,],
                        itemStyle: {
                            color: function (params) {//柱状图设置不同颜色
                                // 给出颜色组
                                let colorList = ["#3CA4D4", "#77BF43","#FCB813", "#7A7B7D", ];
                                return colorList[params.dataIndex]
                            },
                        },
                        label: {
                            show: true,          // 显示标签
                            position: 'right',     // 设置标签在柱体顶部
                            color: '#000',       // 数字颜色
                            fontSize: 12,        // 字体大小
                        },
                    }
                ]
            };
            myChart.setOption(option, true);
        },
    }
};
</script>
<style lang="scss" scoped>
.Project_box {
    border-radius: 8px;
    width: 400px;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #ccc;
    margin: 10px;
    float: left;
    padding: 10px;

    .Project_tit {
        font-size: 18px;
        cursor: pointer;
        white-space: nowrap;        // 不换行
        overflow: hidden;           // 超出隐藏
        text-overflow: ellipsis;    // 超出显示省略号
        &:hover {
            color: #0F8BFD;
        }
    }

    div {
        margin-bottom: 5px;
    }
}
</style>